import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import {
  isLoading,
  isLogin,
  loginError,
  myRoles,
  myProfile,
} from '../../Redux/user-profile/selectors';
import { login, logout, clearLoginError } from '../../Redux/user-profile/actions';
import { withCapacitor } from '../../Util/Capacitors/hoc';

import Menu from './Menu';

const isRoleValid = (menuObj, checkRoles) =>
  menuObj.roles &&
  (menuObj.roles.length === 0 ||
    (menuObj.roles.length > 0 && menuObj.roles.some((role) => checkRoles.indexOf(role) >= 0)));

const filterMenu = (menus = [], isLogin = false, myRoles = []) =>
  menus.filter(
    (menu) => !menu.hideMenu && (menu.private !== true || (isLogin && isRoleValid(menu, myRoles)))
  );

const MapperHOC = compose(
  withRouter,
  connect(
    (state) => ({
      user: myProfile(state) ?? {},
      isLoading: isLoading(state),
      isLogin: isLogin(state),
      loginError: loginError(state),
      myRoles: myRoles(state),
    }),
    {
      login,
      logout,
      clearLoginError,
    }
  ),
  withCapacitor,
  withProps(({ menus, isLogin, myRoles }) => ({
    rendermenus: filterMenu(menus, isLogin, myRoles) || [],
  }))
);

export default MapperHOC(Menu);
